// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__YclxB","selected":"Chip_selected__2k27v"};